/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'envelope': {
    width: 60,
    height: 48,
    viewBox: '0 0 60 48',
    data: '<path d="M54 0H6C4.41391 0.00793057 2.89548 0.643571 1.77674 1.76793C0.658002 2.89229 0.0299801 4.41389 0.03 6L0 42C0.00474818 43.5898 0.638414 45.1132 1.7626 46.2374C2.8868 47.3616 4.41016 47.9953 6 48H54C55.5898 47.9953 57.1132 47.3616 58.2374 46.2374C59.3616 45.1132 59.9953 43.5898 60 42V6C59.9953 4.41016 59.3616 2.8868 58.2374 1.7626C57.1132 0.638414 55.5898 0.00474818 54 0ZM54 12L30 27L6 12V6L30 21L54 6V12Z" fill="#D3C191"/>'
  }
})
